module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_Black.edbd0495.jpg";